import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import VehicleForm from "./vehicleComponents/VehicleForm";

import { useAddVehicleMutation } from "store/services/vehicleApi";

const VehicleCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Vehicles", path: "/app/crm/vehicle/list" },
    { title: "New Vehicle" },
  ];

  // RTK query hook for adding a vehicle
  const [addVehicle, { isLoading }] = useAddVehicleMutation();

  const handleCreateVehicle = async (data) => {
    try {
      const { _id } = await addVehicle(data).unwrap();
      toast.success("Vehicle successfully created!");
      navigate(`/app/crm/vehicle/${_id}/detail`); // Navigate to the newly created vehicle's detail page
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create vehicle!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <VehicleForm isBusy={isLoading} onSubmit={handleCreateVehicle} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VehicleCreateScreen;
